// AUTO-GENERATED - DO NOT EDIT
// Generated from appsettings table (scope = 'client')
export const appSettings = Object.assign({ APP_HOST: '', APP_DOMAIN: '', OWNER_VISIBILITY_ENABLED: false, PAYMENTS_ENABLED: false, PAYMENT_TYPES: '', SHOWCASE_PROPERTY_ID: '', ATTACHMENT_URL: '', SUPPORT_CONTACT: '', PUNCHLIST_PROJECT_ID: '', PUNCHLIST_TOKEN: '', PUNCHLIST_WIDGET_URL: '', USERBACK_KEY: '' }, window.__APP_SETTINGS__);
export default appSettings;
